export default __webpack_public_path__ + "static/media/reload.416849a4.svg";